export enum EnContentType {
    FormData,
    Json,
    XML
}